import { NotFoundPageQuery } from '@custom/schema';
import React from 'react';
import { useTrackRoute } from '../../utils/gtm';
import { isTruthy } from '../../utils/isTruthy';
import { LanguageNegotiator } from '../../utils/language-negotiator';
import { withOperation } from '../../utils/with-operation';
import { PageDisplay } from '../Organisms/PageDisplay';
export var NotFoundPage = withOperation(NotFoundPageQuery, function(param) {
    var websiteSettings = param.websiteSettings;
    var _websiteSettings_notFoundPage_translations, _websiteSettings_notFoundPage;
    useTrackRoute('404 Not Found');
    var pages = (websiteSettings === null || websiteSettings === void 0 ? void 0 : (_websiteSettings_notFoundPage = websiteSettings.notFoundPage) === null || _websiteSettings_notFoundPage === void 0 ? void 0 : (_websiteSettings_notFoundPage_translations = _websiteSettings_notFoundPage.translations) === null || _websiteSettings_notFoundPage_translations === void 0 ? void 0 : _websiteSettings_notFoundPage_translations.filter(isTruthy).filter(function(page) {
        return Boolean(page && page.locale);
    })) || [];
    return pages.length > 0 ? /*#__PURE__*/ React.createElement(React.Fragment, null, pages.map(function(page) {
        return /*#__PURE__*/ React.createElement(LanguageNegotiator, {
            locale: page.locale,
            key: page.id
        }, /*#__PURE__*/ React.createElement(PageDisplay, page));
    })) : /*#__PURE__*/ React.createElement("div", null);
});
